export default "__VITE_ASSET__D76Y5IuS__"